import { useMemo } from "react";
import { THEMES } from "@theme/index";
import useConfigName from "@hooks/useConfigName";

const useInterfaceConfig = () => {
  const configName = useConfigName();
  return useMemo(() => {
    const config = THEMES[configName as keyof typeof THEMES];
    return config.interfaceConfig;
  }, [configName]);
};

export default useInterfaceConfig;
